import React, { Component } from "react"
import { Card } from "material-ui/Card"
import { Flex, Box } from "rebass"
import { connect } from "react-redux"
import { find, groupBy, toArray, orderBy } from "lodash"
import compose from "recompose/compose"
import {
  showNotification as showNotificationAction,
  GET_ONE,
  GET_MANY,
} from "admin-on-rest"
import ContainerDimensions from "react-container-dimensions"
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts"
import Moment from "moment"
import { extendMoment } from "moment-range"
import { nest, ascending, merge, sum } from "d3"

import DatePicker from "material-ui/DatePicker"
import RaisedButton from "material-ui/RaisedButton"
import { ViewTitle } from "../../components"
import {
  RestApiChartContent,
  RestClient,
  RestApiChartState,
} from "../../restClient"
import { HeaderTitleChart } from "./styled"

const defaultMarketerName = "Default"

const generateColor = () => {
  return (
    "#" +
    Math.random()
      .toString(16)
      .substr(-6)
  )
}

const moment = extendMoment(Moment)

class ContentChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contentId: props.match.params.id,
      fromDate: moment()
        .subtract(6, "d")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      dataViews: [],
      defaultViews: [],
      defaultState: [],
      dataState: [],
      content: {},
      datakeyX: [],
      datakeyState: [],
      marketersId: [],
      dataMarketers: [],
    }
  }

  componentWillMount() {
    const { fromDate, toDate } = this.state
    this.getContent()
    this.setDefaultRangeDate(fromDate, toDate)
  }

  setDefaultRangeDate = (fromDate, toDate) => {
    const range = moment.range(fromDate, toDate)
    const acc = Array.from(
      range.by("days", { excludeStart: false, excludeEnd: false })
    )
    const resultView = acc.map(m => {
      return {
        date: m.format("YYYY-MM-DD"),
        marketer_id: 0,
        marketer_name: "",
        slug: "",
        type: "",
        count: 0,
        views: 0,
      }
    })

    const resultState = acc.map(m => {
      return {
        created_at: "",
        date: m.format("YYYY-MM-DD"),
        marketer_id: 0,
        marketer_name: defaultMarketerName,
        sku: "",
        qty: 0,
      }
    })

    this.setState({
      defaultViews: resultView,
      defaultState: resultState,
    })
  }

  getCharts(contentId, startDate, endDate) {
    RestApiChartContent(contentId, startDate, endDate)
      .then(response => response.json())
      .then(items => {
        if (items && !items.message) {
          this.setState({
            dataViews: this.getDataViews(items),
          })
        } else {
          this.props.showNotification(items.message, "warning")
        }
      })
      .catch(e => {
        // console.log(e);
      })
  }
  getChartsState(contentId, startDate, endDate) {
    RestApiChartState(contentId, startDate, endDate)
      .then(response => response.json())
      .then(items => {
        console.log(items)
        if (items && !items.message) {
          this.setState({
            dataState: this.getDataState(items),
          })
        } else {
          this.props.showNotification(items.message, "warning")
        }
      })
      .catch(e => {
        // console.log(e);
      })
  }

  getContent = () => {
    RestClient(GET_ONE, "contents", { id: this.state.contentId })
      .then(items => {
        if (items && items.data) {
          // console.log(items.data)
          const { data } = items
          const newMarketers = []
          const marketerId = []
          data.marketers.map(item => {
            item["color"] = generateColor()
            newMarketers.push(item)
            marketerId.push(item.marketer_id)
            return item
          })

          const slugItem = [
            { marketer_id: 0, slug: data.slug, color: generateColor() },
            ...newMarketers,
          ]

          this.setState({
            content: items.data,
            datakeyX: slugItem,
            marketersId: marketerId,
          })
          const { fromDate, toDate, contentId } = this.state
          const startDate = moment(fromDate).format("YYYY-MM-DD")
          const endDate = moment(toDate).format("YYYY-MM-DD")
          this.getCharts(contentId, startDate, endDate)
          this.getMarketers(marketerId)
        }
      })
      .catch(e => {
        console.error(e)
      })
  }
  getMarketers = marketers => {
    RestClient(GET_MANY, "marketers", { ids: marketers })
      .then(items => {
        if (items && items.data) {
          const newMarketers = []
          const { data } = items
          data.map(item => {
            item["color"] = generateColor()
            item["marketer_name"] = item.first_name + " " + item.last_name
            item["marketer_id"] = item.id
            newMarketers.push(item)
            return item
          })

          const stateItem = [
            {
              marketer_id: 0,
              marketer_name: defaultMarketerName,
              color: generateColor(),
            },
            ...newMarketers,
          ]
          console.log(stateItem)
          this.setState({
            dataMarketers: items.data,
            datakeyState: stateItem,
          })
        }
        const { fromDate, toDate, contentId } = this.state
        const startDate = moment(fromDate).format("YYYY-MM-DD")
        const endDate = moment(toDate).format("YYYY-MM-DD")
        this.getChartsState(contentId, startDate, endDate)
      })
      .catch(e => {
        console.error(e)
      })
  }

  getDataViews = data => {
    const newData = data.map((item, index) => {
      let contentData = item
      contentData["date"] = moment(item.created_at).format("YYYY-MM-DD")
      return contentData
    })

    const newDataViews = merge([newData, this.state.defaultViews])
    const { datakeyX } = this.state
    let dataViews = nest()
      .key(function(d) {
        // console.log(d)
        return moment(d.date).format("YYYY-MM-DD")
      })
      .sortKeys(ascending)
      .rollup(function(view) {
        let contentKey = {}
        view.map(item => {
          datakeyX.map(value => {
            if (item.id) {
              if (value.marketer_id === item.marketer_id) {
                contentKey[value.slug] = item.count
              }
            }
            return {}
          })
          return {}
        })
        return contentKey
      })
      .entries(newDataViews)
      .map(function(group) {
        let newValue = group.value
        newValue["date"] = group.key
        return newValue
      })

    return dataViews
  }

  getDataState = data => {
    const newData = data.map((item, index) => {
      let contentData = item
      contentData["date"] = moment(item.created_at).format("YYYY-MM-DD")
      return contentData
    })
    const { dataMarketers } = this.state
    let dataSample = nest()
      .key(function(d) {
        return d.marketer_id
      })
      .sortKeys(ascending)
      .rollup(function(view) {
        let contentKey = {}
        view.map(state => {
          contentKey = state
          return contentKey
        })

        if (contentKey.marketer_id === 0) {
          contentKey["marketer_name"] = defaultMarketerName
        } else {
          const marketer = find(dataMarketers, { id: contentKey.marketer_id })
          contentKey["marketer_name"] =
            marketer.first_name + " " + marketer.last_name
        }
        contentKey["qty"] = sum(view, function(d) {
          return d.qty
        })
        return contentKey
      })
      .entries(newData)
      .map(function(group) {
        return group.value
      })

    const dataState = merge([dataSample, this.state.defaultState])
    const objtoArray = groupBy(dataState, "date")
    const newArray = toArray(objtoArray)

    const newDataState = newArray.map(item => {
      // console.log(item)
      let newObject = {}
      newObject[defaultMarketerName] = 0
      item.map(value => {
        // console.log(value)
        if (value.marketer_id !== 0) {
          newObject[value.marketer_name] = value.qty
        } else {
          if (value.marketer_id === 0 && value.qty > 0) {
            newObject[defaultMarketerName] = value.qty
          }
        }
        newObject["date"] = value.date
        return newObject
      })
      return newObject
    })
    const sortData = orderBy(newDataState, ["date"], ["asc"])
    return sortData
  }

  handleChangeFromDate = (event, date) => {
    this.setState({
      fromDate: date,
    })
  }

  handleChangeToDate = (event, date) => {
    this.setState({
      toDate: date,
    })
  }

  onSubmit = () => {
    const { fromDate, toDate, contentId } = this.state
    const startDate = moment(fromDate).format("YYYY-MM-DD")
    const endDate = moment(toDate).format("YYYY-MM-DD")
    this.setDefaultRangeDate(fromDate, toDate)
    this.getCharts(contentId, startDate, endDate)
    this.getChartsState(contentId, startDate, endDate)
  }
  render() {
    const { dataViews, datakeyX, datakeyState, dataState } = this.state

    return (
      <Card containerStyle={{ minHeight: 318 }}>
        <ViewTitle title={<HeaderTitleChart {...this.props} />} />
        <Flex
          w={[1]}
          p={[1]}
          px={[2]}
          wrap
          direction={["row"]}
          align={["center"]}
        >
          <Box p={[1]}>
            <DatePicker
              onChange={this.handleChangeFromDate}
              autoOk={true}
              floatingLabelText="From Date"
              value={new Date(this.state.fromDate)}
            />
          </Box>
          <Box p={[1]}>
            <DatePicker
              onChange={this.handleChangeToDate}
              autoOk={true}
              floatingLabelText="To Date"
              value={new Date(this.state.toDate)}
              minDate={new Date(this.state.fromDate)}
            />
          </Box>
          <Box p={[1]}>
            <RaisedButton
              label="Search"
              primary={true}
              onClick={this.onSubmit}
            />
          </Box>
        </Flex>
        <Box w={[1]} p={[2]}>
          <ContainerDimensions>
            {({ width, height }) => {
              let mainWidth = width - 50
              let mainHeight = mainWidth / 2
              if (width < 600) {
                // mainWidth = 800;
                mainHeight = mainWidth / 1.8
              }
              return (
                <Box w={[1]}>
                  <AreaChart
                    width={mainWidth}
                    height={mainHeight}
                    data={dataViews}
                    margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                  >
                    <defs>
                      {datakeyX.length > 0 &&
                        datakeyX.map((itemchart1, index) => {
                          return (
                            <linearGradient
                              id="colorUv"
                              x1="0"
                              y1="0"
                              x2="0"
                              y2="1"
                              key={index}
                            >
                              <stop
                                offset="5%"
                                stopColor={itemchart1.color}
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="95%"
                                stopColor={itemchart1.color}
                                stopOpacity={0}
                              />
                            </linearGradient>
                          )
                        })}
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    {datakeyX.length > 0 &&
                      datakeyX.map((item, index) => {
                        return (
                          <Area
                            key={item.marketer_id}
                            type="monotone"
                            dataKey={item.slug}
                            stackId="1"
                            stroke={item.color}
                            fill={item.color}
                          />
                        )
                      })}
                  </AreaChart>
                  <Box w={[1]} pt={[2]} pb={[2]}>
                    <AreaChart
                      width={mainWidth}
                      height={mainHeight}
                      data={dataState}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                      <defs>
                        {datakeyState.length > 0 &&
                          datakeyState.map((itemchart2, index) => {
                            return (
                              <linearGradient
                                key={index}
                                id="colorUv"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor={itemchart2.color}
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor={itemchart2.color}
                                  stopOpacity={0}
                                />
                              </linearGradient>
                            )
                          })}
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <Tooltip />
                      {datakeyState.length > 0 &&
                        datakeyState.map(item => (
                          <Area
                            key={item.marketer_id}
                            type="monotone"
                            dataKey={item.marketer_name}
                            stackId="1"
                            stroke={item.color}
                            fill={item.color}
                          />
                        ))}
                    </AreaChart>
                  </Box>
                </Box>
              )
            }}
          </ContainerDimensions>
        </Box>
      </Card>
    )
  }
}

const enhance = compose(
  connect(
    (state, props) => {
      return {}
    },
    { showNotification: showNotificationAction }
  )
)

export default enhance(ContentChart)



// WEBPACK FOOTER //
// ./src/contents/chart/ContentChart.js